const reloadKey = 'APP_VERSION';

const CURRENT_APP_VERSION = localStorage.getItem(reloadKey) || '0.0';

export function checkAndReloadOnVersionChange(): void {
    async function checkVersion() {
        try {
            const response = await fetch("/version.json");
            if (!response.ok) return;

            const data = await response.json();
            const serverVersion = data?.version;

            if (serverVersion && serverVersion !== CURRENT_APP_VERSION) {
                const lastAttemptedVersion = localStorage.getItem(reloadKey);

                if (lastAttemptedVersion === serverVersion) {
                    return;
                }

                localStorage.setItem(reloadKey, serverVersion);

                window.location.reload();
            }
        } catch {
        }
    }

    checkVersion();
}
